import { processAttributesTable as processAttributesTableDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type ProcessAttributesTable = {
    attribute: string;
    attributeType: string;
}

export const processAttributesTable = ({
    attribute,
    attributeType,
}: ProcessAttributesTable)  =>
    processAttributesTableDiagram(attribute, attributeType);
